/**
 * @description: menu type
 */
export const MenuTypeEnum = {
  // left menu
  SIDEBAR: 'sidebar',

  MIX_SIDEBAR: 'mix-sidebar',
  // mixin menu
  MIX: 'mix',
  // top menu
  TOP_MENU: 'top-menu',
} as const;

export type MenuTypeEnum = (typeof MenuTypeEnum)[keyof typeof MenuTypeEnum];

// 折叠触发器位置
export const TriggerEnum = {
  // 不显示
  NONE: 'NONE',
  // 菜单底部
  FOOTER: 'FOOTER',
  // 头部
  HEADER: 'HEADER',
} as const;

export type TriggerEnum = (typeof TriggerEnum)[keyof typeof TriggerEnum];

export type Mode = 'vertical' | 'vertical-right' | 'horizontal' | 'inline';

// menu mode
export const MenuModeEnum = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
  VERTICAL_RIGHT: 'vertical-right',
  INLINE: 'inline',
} as const;

export type MenuModeEnum = (typeof MenuModeEnum)[keyof typeof MenuModeEnum];

export const MixSidebarTriggerEnum = {
  HOVER: 'hover',
  CLICK: 'click',
} as const;

export type MixSidebarTriggerEnum =
  (typeof MixSidebarTriggerEnum)[keyof typeof MixSidebarTriggerEnum];
